// Welle N2: Wie eine Einzelnote zählt — Text für „Note eintragen“, vor dem Speichern.
// Regel (Server, lib/mdl-berechnung.js): Klassenarbeiten und Tests ergeben den schriftlichen
// Teil (gewichtet); Noten der Art Mündlich/Sonstiges zählen im mündlichen Teil wie so viele
// Wochen Mitarbeit, wie ihre Gewichtung angibt.

const zahl = (g: number) => String(g).replace('.', ',');

export function zaehltText(art: string, gewicht: number): string {
  if (art === 'KA' || art === 'Test') {
    return gewicht === 1 ? 'Zählt einfach im schriftlichen Teil.' : `Zählt im schriftlichen Teil ${zahl(gewicht)}-fach.`;
  }
  if (gewicht === 0.5) return 'Zählt im mündlichen Teil wie eine halbe Woche Mitarbeit.';
  return `Zählt im mündlichen Teil wie ${zahl(gewicht)} ${gewicht === 1 ? 'Woche' : 'Wochen'} Mitarbeit.`;
}
